import { CtxMapV2 } from 'components/mapV2/contexts/CtxMapV2';
import { MapV2Button } from 'components/mapV2/elements/MapV2Button';
import { MapV2LanguageSwitch } from 'components/mapV2/elements/MapV2LanguageSwitch';
import { MapV2SearchInput } from 'components/mapV2/elements/MapV2SearchInput';
import { useContext } from 'react';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const MapV2ModalListHeader = (props: Props): JSX.Element => {
    const ctxMapV2 = useContext(CtxMapV2);
    const isWide = ctxMapV2.isWide;

    return (
        <S_MapV2ModalListHeader className={props.className}>
            <S_Row1>
                <S_MapV2SearchInput
                    placeholder={Localization.MAP_V2_SEARCH_THIS_MAP}
                    value={ctxMapV2.search.value}
                    onChange={ctxMapV2.search.setValue}
                    onFocus={() => {
                        if (!isWide) {
                            ctxMapV2.mobileModalState.setSize('large');
                        }
                        if (!isWide) {
                            ctxMapV2.fullscreen.turnOn();
                        }
                        if (isWide) {
                            if (!ctxMapV2.pcModalState.isExpanded) {
                                ctxMapV2.pcModalState.toggle();
                            }
                        }
                    }}
                />
                {!ctxMapV2.isIframe && !isWide && <MapV2LanguageSwitch />}
            </S_Row1>
            {isWide && (
                <S_Row2>
                    <MapV2Button
                        label={
                            ctxMapV2.pcModalState.isExpanded
                                ? Localization.MAP_V2_COLLAPSE
                                : Localization.MAP_V2_EXPAND
                        }
                        icon={{
                            prefix: 'fas',
                            iconName: ctxMapV2.pcModalState.isExpanded ? 'caret-up' : 'caret-down'
                        }}
                        type={'dark'}
                        onClick={ctxMapV2.pcModalState.toggle}
                    />

                    {!ctxMapV2.isIframe && <MapV2LanguageSwitch />}
                </S_Row2>
            )}
        </S_MapV2ModalListHeader>
    );
};

const S_MapV2ModalListHeader = styled.div`
    display: flex;
    flex-direction: column;
    gap: 15px;
    padding: 15px;
    position: relative;
`;

const S_Row1 = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 15px;
`;

const S_Row2 = styled.div`
    display: flex;
    flex-direction: row;
    gap: 15px;
    align-items: center;
    justify-content: space-between;
`;

const S_MapV2SearchInput = styled(MapV2SearchInput)``;
